module.exports = __webpack_public_path__ + "d7aea0fba46b6d8548ef6d7d272239b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003C4S.png
// module id = 1538
// module chunks = 0